import React, { Component } from 'react';
import { Route, Link, Switch  } from 'react-router-dom';
import PropTypes from 'prop-types';
import PushNotifications from './PushNotifications';
import PushNotifications2 from './PushNotifications2';
import AddNewPush from './AddNewPush';
import PushDetails from './details/PushDetails';
import SentMessages from './SentMessages';
import CustomerGroups from './CustomerGroups';
import AddNewCustomerGroup from './AddNewCustomerGroup';


export default class PushNotificationsPage extends Component {

  /**
   * Get active tab
   *
   * @returns {string}
   */
  getActiveTab() {
    let active = 'promotional';
    let currentPath = this.context.router.route.location.pathname;

    if(currentPath.match(/\/push-notifications\/system.*/)) {
      active = 'system';
    }

    return active;
  }


  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    let activeTab = this.getActiveTab();

    return (
      <div className="dashboard-management">
          <h1><i className="fa fa-bell" aria-hidden="true"></i> Push Notifications</h1>
          {/* <nav>
            <ul className="dashboard-management-nav customers-dashboard-nav">
                <li className={activeTab === 'promotional' ? 'active' : ''} style={{maxWidth: '20%'}}>
                  <Link to="/push-notifications"  id="promotional">Promotional notifications</Link>
                </li>
                <li className={activeTab === 'system' ? 'active' : ''} style={{maxWidth: '20%'}}>
                  <Link to="/push-notifications/system" id="system">System notifications</Link>
                </li>
            </ul>
          </nav> */}

          <Switch>
            <Route path="/push-notifications/push-details/" component={PushDetails}/>
            <Route path="/push-notifications/add-new" component={AddNewPush}/>
            <Route path="/push-notifications/system" component={PushNotifications2}/>
            <Route path="/push-notifications/sent-messages" component={SentMessages}/>
            <Route path="/push-notifications/customer-groups/add-new" component={AddNewCustomerGroup}/>
            <Route path="/push-notifications/customer-groups" component={CustomerGroups}/>
            <Route path="/push-notifications" component={PushNotifications}/>
          </Switch>

      </div>
    );
  }

}

// Inject router
PushNotificationsPage.contextTypes = {
  router: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/push/PushNotificationsPage.js